@if (data.error()) {
  <p-message severity="error" styleClass="mb-4">{{ data.error() }}</p-message>
} @else {
  <table class="detail-table">
    <tr>
      <td class="detail-label">Pr.dato</td>
      <td>
        <p-date-picker
          [(ngModel)]="kundeService.helbredsDato"
          [showIcon]="true"
          dateFormat="dd-mm-yy" />
      </td>
    </tr>
    @if (data.value()) {
      <tr>
        <td class="detail-label align-top">Helbredsgodkendelse</td>
        <td>
          <table>
            <tbody>
              <tr>
                <td>Sygdomsdækning</td>
                <td>
                  <app-checkmark
                    [checked]="
                      getHelbredsgodkendelse('LetsikringAfSygdom67')
                    " />
                </td>
              </tr>
              <tr>
                <td>Dødsfaldsdækning</td>
                <td>
                  <app-checkmark
                    [checked]="getHelbredsgodkendelse('LetsikringVedDoed')" />
                </td>
              </tr>
              <tr>
                <td>Kritisk sygdom</td>
                <td>
                  <app-checkmark
                    [checked]="
                      getHelbredsgodkendelse('LetsikringVedKritiskSygdom')
                    " />
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <div
                    class="helbred"
                    [class]="getHelbredsgodkendelseFarve().className">
                    {{ getHelbredsgodkendelseFarve().text }} helbred
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td class="detail-label">Helbredsscore</td>

        <td>
          <table class="detail-table bordered nomargin">
            <thead>
              <tr>
                <th>Sygdom</th>
                <th>Død</th>
                <th>Kritisk sygdom</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ data.value()?.sygdomScore | number: '1.1' }}</td>
                <td>{{ data.value()?.doedScore | number: '1.1' }}</td>
                <td>{{ data.value()?.kritiskSygdomScore | number: '1.1' }}</td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td class="detail-label">Jobscore</td>
        <td>
          <table class="detail-table bordered nomargin">
            <tbody>
              <tr>
                <td>{{ data.value()?.jobScore | number: '1.1' }}</td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td class="detail-label">Gældende fra</td>
        <td>{{ data.value()?.gaeldendeFra | date: 'dd-MM-yyyy' }}</td>
      </tr>
      <tr>
        <td class="detail-label">Gældende til</td>
        <td>{{ data.value()?.gaeldendeTil | date: 'dd-MM-yyyy' }}</td>
      </tr>
      <tr>
        <td class="detail-label">Oprettet</td>
        <td>{{ data.value()?.oprettelsesDato | date: 'dd-MM-yyyy HH:mm' }}</td>
      </tr>
      <tr>
        <td class="detail-label">Manuelt indtastet</td>
        <td>{{ data.value()?.manueltIndtastet | boolean }}</td>
      </tr>
      <tr>
        <td class="detail-label">Manuelt indtastet af</td>
        <td>{{ data.value()?.manueltIndtastetAf }}</td>
      </tr>
    } @else {
      <tr>
        <td></td>
        <td>Der er ingen registreret helbredsscore pr. den givne dato</td>
      </tr>
    }
    @if (allowIndtastHelbred()) {
      <tr>
        <td></td>
        <td>
          <p-button
            icon="pi pi-heart"
            label="Indtast manuel helbred"
            (click)="onClickEnterManueltHelbred()"></p-button>
        </td>
      </tr>
    }
  </table>

  <p-dialog
    header="Indtast manuel helbredsscore"
    [modal]="true"
    [(visible)]="showManueltHelbredDialog"
    [style]="{ width: '358px' }">
    <div class="flex items-center gap-4 mb-4">
      <label class="font-semibold w-40">Sygdom</label>
      <p-input-number
        [(ngModel)]="manuelScoreSygdom"
        locale="da"
        [maxFractionDigits]="2"
        mode="decimal" />
    </div>
    <div class="flex items-center gap-4 mb-4">
      <label class="font-semibold w-40">Død</label>
      <p-input-number
        [(ngModel)]="manuelScoreDoed"
        locale="da"
        [maxFractionDigits]="2"
        mode="decimal" />
    </div>
    <div class="flex items-center gap-4 mb-4">
      <label class="font-semibold w-40">Kritisk sygdom</label>
      <p-input-number
        [(ngModel)]="manuelScoreKritiskSygdom"
        locale="da"
        [maxFractionDigits]="2"
        mode="decimal" />
    </div>
    <div class="flex items-center gap-4 mb-4">
      <label class="font-semibold w-40">Jobscore</label>
      <p-input-number
        [(ngModel)]="manuelScoreJob"
        locale="da"
        [maxFractionDigits]="2"
        mode="decimal" />
    </div>
    <div class="flex justify-end gap-2">
      <p-button
        label="Fortryd"
        severity="secondary"
        (click)="onClickCancelManueltHelbred()" />
      <p-button
        label="Gem"
        [loading]="saving()"
        (click)="onClickSaveManueltHelbred()" />
    </div>
    @if (messages().length > 0) {
      <p-message severity="error" styleClass="mt-4">
        <ul>
          @for (m of messages(); track m) {
            <li>{{ m }}</li>
          }
        </ul>
      </p-message>
    }
  </p-dialog>
}
